import { useEffect, useState } from "react";
import { useMail } from "contexts/mailContext/mailContext";
import { useLocation } from "react-router-dom";

const useUploadComplete = () => {
  const { getMailMetaData } = useMail();
  const location = useLocation();

  const [showSideBar, setShowSideBar] = useState(false);

  const galleryMailLink = getMailMetaData().shortUrl;
  const isSizeValidation =
    getMailMetaData().expectedFilesCount !== getMailMetaData().filesCount;
  // const conditionShowPickerPromo =
  //   showPickerPromo &&
  //   getMailMetaData().IsContainOnlyImages &&
  //   getMailMetaData().filesCount > 100;

  const handleCloseSidebar = () => {
    setShowSideBar(false);
  };

  useEffect(() => {
    setShowSideBar(true);
  }, []);

  useEffect(() => {
    const newUrl =
      location.pathname.replace("/upload-complete", "") + location.search;
    window.history.pushState({}, "", newUrl);
  }, []);

  return {
    isSizeValidation,
    galleryMailLink,
    showSideBar,
    handleCloseSidebar,
  };
};

export default useUploadComplete;
